import { queryOptions } from "@tanstack/react-query";
import { z } from "zod";
import { api, expectOk } from "../../lib/api";
import { keys } from "../../lib/keys";

/** `/schedule?week=&specialist=` — same URL keys as the Next page. */
export const ScheduleSearch = z.object({
  week: z.string().max(32).optional(),
  specialist: z.string().max(64).optional(),
});
export type ScheduleSearch = z.infer<typeof ScheduleSearch>;

/** `/schedule/new?date=&specialist=&patient=` (`patient` preselects the typeahead). */
export const BookingSearch = z.object({
  date: z.string().max(32).optional(),
  specialist: z.string().max(64).optional(),
  patient: z.string().max(64).optional(),
});
export type BookingSearch = z.infer<typeof BookingSearch>;

export const scheduleWeekQuery = (week?: string, specialist?: string) =>
  queryOptions({
    queryKey: keys.schedule(week ?? "current", specialist),
    queryFn: async () =>
      expectOk(
        await api.appointments.scheduleWeek({
          query: { ...(week ? { week } : {}), ...(specialist ? { specialistId: specialist } : {}) },
        }),
        200,
      ),
  });

/** Under the `schedule` prefix on purpose: a booking invalidates it along with the week. */
export const bookingContextQuery = (specialist?: string, date?: string) =>
  queryOptions({
    queryKey: ["schedule", "booking-context", specialist ?? "", date ?? ""] as const,
    queryFn: async () =>
      expectOk(
        await api.appointments.bookingContext({
          query: { ...(specialist ? { specialistId: specialist } : {}), ...(date ? { date } : {}) },
        }),
        200,
      ),
  });
